module.exports = __webpack_public_path__ + "static/media/star_grey.f88d3f07.png";